require('videogular');
require('./vg-buffering');

module.exports = 'com.2fdevs.videogular.plugins.buffering';



//////////////////
// WEBPACK FOOTER
// ./~/videogular-buffering/index.js
// module id = ./node_modules/videogular-buffering/index.js
// module chunks = 1